(function () {
  if (window.__productVariantMediaInit) return;
  window.__productVariantMediaInit = true;

  const handleize = (value) =>
    (value || '')
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const getSelectedColorHandleFromPicker = (gallery) => {
    const position = parseInt(gallery.dataset.colorOptionPosition || '0', 10);
    if (position <= 0) return '';

    const productInfo = gallery.closest('product-info');
    const variantSelects = productInfo?.querySelector('variant-selects');
    if (!variantSelects) return '';

    const nameSuffix = `-${position}`;
    const checkedRadio = variantSelects.querySelector(`input:checked[name$="${nameSuffix}"]`);
    if (checkedRadio?.value) return handleize(checkedRadio.value);

    const groups = variantSelects.querySelectorAll('fieldset.js, .product-form__input--dropdown');
    const group = groups[position - 1];
    if (group) {
      const select = group.querySelector('select');
      if (select?.value) return handleize(select.value);

      const checked = group.querySelector('input:checked');
      if (checked?.value) return handleize(checked.value);

      const selectedValue = group.querySelector('[data-selected-value]');
      if (selectedValue?.textContent) return handleize(selectedValue.textContent);
    }

    return '';
  };

  const getVariantColorHandle = (gallery, variant) => {
    const position = parseInt(gallery.dataset.colorOptionPosition || '0', 10);
    if (position > 0 && variant?.[`option${position}`]) {
      return handleize(variant[`option${position}`]);
    }

    const fromPicker = getSelectedColorHandleFromPicker(gallery);
    if (fromPicker) return fromPicker;

    return gallery.dataset.initialColorHandle || '';
  };

  const getSectionId = (gallery) => gallery?.id?.replace('MediaGallery-', '') || '';

  const getFeaturedMediaIdForColor = (gallery, colorHandle, variant) => {
    if (variant?.featured_media?.id) return variant.featured_media.id;
    if (!colorHandle || !gallery?.dataset?.variantMediaByColor) return null;

    try {
      const map = JSON.parse(gallery.dataset.variantMediaByColor);
      return map[colorHandle] ?? null;
    } catch (error) {
      return null;
    }
  };

  const revealFeaturedMedia = (items, featuredMediaId, getMediaId, visibleItems, activeClass) => {
    if (!featuredMediaId) return;

    const featuredId = String(featuredMediaId);
    items.forEach((item) => {
      const mediaId = getMediaId(item);
      const matchesFeatured = mediaId.includes(featuredId);
      item.hidden = !matchesFeatured;
      item.classList.remove(activeClass);
      if (matchesFeatured) visibleItems.push(item);
    });
  };

  const mediaIdFromGallerySlide = (slide) => {
    const fullId = slide?.dataset?.mediaId || '';
    const separator = fullId.lastIndexOf('-');
    return separator >= 0 ? fullId.slice(separator + 1) : fullId;
  };

  const syncModalOrder = (sectionId) => {
    if (!sectionId) return;

    const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
    const content = document.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
    if (!gallery || !content) return;

    const modalByMediaId = new Map();
    Array.from(content.children).forEach((item) => {
      const mediaId = item.dataset.mediaId || item.querySelector('[data-media-id]')?.dataset.mediaId || '';
      if (mediaId) modalByMediaId.set(String(mediaId), item);
    });

    gallery.querySelectorAll('.product__media-item[data-media-id]').forEach((slide) => {
      const modalItem = modalByMediaId.get(mediaIdFromGallerySlide(slide));
      if (modalItem) content.appendChild(modalItem);
    });
  };

  const filterModal = (sectionId, colorHandle, variant) => {
    if (!sectionId) return;

    syncModalOrder(sectionId);

    const modal = document.querySelector(`#ProductModal-${sectionId}`);
    const content = modal?.querySelector('.product-media-modal__content');
    if (!content) return;

    const items = Array.from(content.children);
    const labeledItems = items.filter((item) => item.dataset.colorHandle);

    if (!colorHandle || labeledItems.length === 0) {
      items.forEach((item) => {
        item.hidden = false;
      });
      return;
    }

    let visibleItems = [];
    items.forEach((item) => {
      const handle = item.dataset.colorHandle || '';
      const show = !handle || handle === colorHandle;
      item.hidden = !show;
      item.classList.remove('active');
      if (show) visibleItems.push(item);
    });

    if (visibleItems.length === 0) {
      const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
      const featuredMediaId = getFeaturedMediaIdForColor(gallery, colorHandle, variant);
      revealFeaturedMedia(
        items,
        featuredMediaId,
        (item) => item.dataset.mediaId || item.querySelector('[data-media-id]')?.dataset.mediaId || '',
        visibleItems,
        'active'
      );
    }
  };

  const filterGallery = (gallery, colorHandle, variant) => {
    if (!gallery) return;

    const items = Array.from(gallery.querySelectorAll('.product__media-item'));
    const labeledItems = items.filter((item) => item.dataset.colorHandle);
    if (!colorHandle || labeledItems.length === 0) {
      items.forEach((item) => {
        item.hidden = false;
      });
      refreshMobileSlider(gallery, items[0]);
      filterModal(getSectionId(gallery), colorHandle, variant);
      return;
    }

    let visibleItems = [];
    items.forEach((item) => {
      const handle = item.dataset.colorHandle || '';
      const show = !handle || handle === colorHandle;
      item.hidden = !show;
      item.classList.remove('is-active');
      if (show) visibleItems.push(item);
    });

    if (visibleItems.length === 0) {
      const featuredMediaId = getFeaturedMediaIdForColor(gallery, colorHandle, variant);
      if (featuredMediaId) {
        const featuredKey = `-${featuredMediaId}`;
        items.forEach((item) => {
          const matchesFeatured = item.dataset.mediaId?.endsWith(featuredKey);
          item.hidden = !matchesFeatured;
          item.classList.remove('is-active');
          if (matchesFeatured) visibleItems.push(item);
        });
      }
    }

    const firstVisible = visibleItems[0];
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (firstVisible) {
      firstVisible.classList.add('is-active');
      if (
        !isMobile &&
        typeof gallery.setActiveMedia === 'function' &&
        firstVisible.dataset.mediaId
      ) {
        gallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      }
    }

    gallery.querySelectorAll('.thumbnail-list__item').forEach((thumb) => {
      const slide = gallery.querySelector(`[data-media-id="${thumb.dataset.target}"]`);
      thumb.hidden = Boolean(slide?.hidden);
    });

    refreshMobileSlider(gallery, firstVisible);
    filterModal(getSectionId(gallery), colorHandle, variant);
  };

  const refreshMobileSlider = (gallery, firstVisible) => {
    const sliderComponent = gallery.querySelector('slider-component.product-gallery-slider');
    const slider = gallery.querySelector('[id^="Slider-Gallery-"]');

    if (sliderComponent?.resetPages) {
      sliderComponent.resetPages();
    }

    if (slider) {
      requestAnimationFrame(() => {
        if (sliderComponent?.resetPages) {
          sliderComponent.resetPages();
        }
        slider.scrollLeft = firstVisible ? firstVisible.offsetLeft : 0;
        slider.dispatchEvent(new Event('scroll', { bubbles: true }));
      });
    }

    if (typeof window.initProductGallerySlider === 'function') {
      window.initProductGallerySlider();
    }
  };

  const initGallery = (gallery) => {
    const productInfo = gallery.closest('product-info');
    let variant = null;

    if (productInfo) {
      try {
        variant = JSON.parse(
          productInfo.querySelector('variant-selects [data-selected-variant]')?.innerHTML || 'null'
        );
      } catch (error) {
        variant = null;
      }
    }

    const colorHandle = getVariantColorHandle(gallery, variant);
    filterGallery(gallery, colorHandle, variant);
  };

  const initAll = (root = document) => {
    const scope = root?.querySelector ? root : document;
    scope.querySelectorAll('media-gallery[data-color-option-position]').forEach((gallery) => {
      if (parseInt(gallery.dataset.colorOptionPosition || '0', 10) <= 0) return;
      initGallery(gallery);
    });

    scope.querySelectorAll('.product-media-modal__content[data-color-option-position]').forEach((content) => {
      const position = parseInt(content.dataset.colorOptionPosition || '0', 10);
      if (position <= 0) return;

      const modal = content.closest('product-modal');
      const sectionId = modal?.id?.replace('ProductModal-', '');
      if (!sectionId) return;

      const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
      const productInfo = gallery?.closest('product-info');
      let variant = null;

      if (productInfo) {
        try {
          variant = JSON.parse(
            productInfo.querySelector('variant-selects [data-selected-variant]')?.innerHTML || 'null'
          );
        } catch (error) {
          variant = null;
        }
      }

      const colorHandle = gallery
        ? getVariantColorHandle(gallery, variant)
        : content.dataset.initialColorHandle || '';
      filterModal(sectionId, colorHandle, variant);
    });
  };

  window.initProductVariantMedia = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      const { variant, sectionId } = data || {};
      const gallery = document.querySelector(`#MediaGallery-${sectionId}`);
      if (!gallery) return;
      const colorHandle = getVariantColorHandle(gallery, variant);
      filterGallery(gallery, colorHandle, variant);
    });
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.optionValueSelectionChange) {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
      const target = data?.event?.target || data?.target;
      const productInfo = target?.closest?.('product-info');
      if (!productInfo) return;

      productInfo.querySelectorAll('media-gallery[data-color-option-position]').forEach((gallery) => {
        const position = parseInt(gallery.dataset.colorOptionPosition || '0', 10);
        if (position <= 0) return;

        const colorHandle = getSelectedColorHandleFromPicker(gallery);
        if (!colorHandle) return;

        let variant = null;
        try {
          variant = JSON.parse(
            productInfo.querySelector('variant-selects [data-selected-variant]')?.innerHTML || 'null'
          );
        } catch (error) {
          variant = null;
        }

        filterGallery(gallery, colorHandle, variant);
      });
    });
  }
})();
